import { render, staticRenderFns } from "./RecruitingServicesBaseNew.vue?vue&type=template&id=3170f40a&scoped=true"
import script from "./RecruitingServicesBaseNew.vue?vue&type=script&lang=js"
export * from "./RecruitingServicesBaseNew.vue?vue&type=script&lang=js"
import style0 from "./RecruitingServicesBaseNew.vue?vue&type=style&index=0&id=3170f40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170f40a",
  null
  
)

export default component.exports